import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { scrollPromoBodyIntoView } from 'client/utils/scroll';
import { setUserNewEntry } from 'client/redux/modules/userEntryState';
import useClientErrorHandler from 'client/hooks/useClientErrorHandler';
import SecondaryButton from 'client/components/Result/Actions/SecondaryButton';
import DialogReCaptcha from 'components/Dialog/DialogReCaptcha';
import AddIcon from '@material-ui/icons/Add';
import usePasscodeManager from 'client/utils/passcode/usePasscodeManager';
import useSearchParams from 'hooks/useSearchParams';

function PlayNewEntryButton({ btnStyle, onClick = () => {} }) {
    const dispatch = useDispatch();
    const errHandler = useClientErrorHandler();
    const [isCreatingNewEntry, setCreatingNewEntry] = useState(false);
    const { enableReCaptcha, enableQualificationPasscode } = useSelector(s => s.settingPromo);
    const { passcodeRemainingCount } = useSelector(s => s.promoState);
    const [isShowReCaptcha, setShowReCaptcha] = useState(false);
    const { passcode } = usePasscodeManager({
        hasVerifiedPasscodeFirstTime: true
    });
    const searchParams = useSearchParams();
    const isPasscodeExistInUrl = searchParams.has('pcode');

    async function handleClick(recaptchaToken) {
        if (enableReCaptcha && !enableQualificationPasscode && !recaptchaToken) {
            setShowReCaptcha(true);
            return;
        }

        setCreatingNewEntry(true);
        try {
            const isSuccessGetNewEntry = await dispatch(setUserNewEntry(recaptchaToken));
            if (isSuccessGetNewEntry) {
                scrollPromoBodyIntoView();
                onClick();
            }
        } catch (err) {
            errHandler({ err });
        } finally {
            setCreatingNewEntry(false);
        }
    }

    const joinAgainBtnText = (() => {
        // Ref: https://app.clickup.com/36226806/v/dc/12hhqp-9560/12hhqp-78398
        // 如果 pcode 從 URL 傳進來，通常指的是本次的參加資格
        // 在 URL 有pcode 的情境下，不需要設計輸入框的情境，因為用戶通常也不知道 pcode是什麼。
        // pcode只是給客戶"隱形"去卡控資格的方式，並沒有要揭露通關序號
        // 所以結果頁也不需要顯示 "再次參加"
        if (passcode) {
            if (passcodeRemainingCount > 0) {
                return i18n.t('btn.join_counts', {
                    count: passcodeRemainingCount
                });
            } else {
                if (isPasscodeExistInUrl) {
                    //且已使用過，在結果頁不要出現 【再次參加】的按鈕
                    return null;
                }
                return i18n.t('btn.join_again');
            }
        }
        return i18n.t('btn.join_again');
    })();

    if (joinAgainBtnText === null) {
        return null;
    }

    return (
        <>
            <SecondaryButton
                IconComponent={passcode && passcodeRemainingCount > 0 ? AddIcon : null}
                text={joinAgainBtnText}
                onClick={handleClick}
                btnStyle={btnStyle}
                isLoading={isCreatingNewEntry}
                disabled={isCreatingNewEntry}
            />
            {isShowReCaptcha && (
                <DialogReCaptcha onOpen={setShowReCaptcha} onComplete={handleClick} />
            )}
        </>
    );
}

export default PlayNewEntryButton;
